/*
 * @Author: ≡Christine 1204356932@qq.com
 * @Date: 2024-10-15 11:25:33
 * @LastEditors: ≡Christine 1204356932@qq.com
 * @LastEditTime: 2024-12-19 11:03:51
 * @FilePath: \management-portal\src\router\modules\customize.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { RouteRecordRaw } from 'vue-router';

export default {
  path: '/customize',
  name: 'customize',
  redirect: '/customize/website/websiteList',
  component: () => import('@/layout/index.vue'),
  meta: {
    title: 'menus.customize',
    icon: 'el-icon-brush',
    sort: 4
  },
  children: [
    {
      path: '/customize/visitConfig/index',
      name: 'customize_visitConfig',
      component: () => import('@/views/customize/visitConfig/index.vue'),
      meta: {
        title: 'menus.customize_visitConfig',
        icon: 'el-icon-Orange'
      }
    },
    {
      path: '/customize/miniapp/index',
      name: 'customize_miniapp',
      component: () => import('@/views/customize/miniapp/index.vue'),
      meta: {
        title: 'menus.customizeMiniapp',
        icon: 'el-icon-Brush'
      }
    },
    {
      path: '/customize/miniapp/detail',
      name: 'customize_miniappDetail',
      component: () => import('@/views/customize/miniapp/detail.vue'),
      meta: {
        title: 'menus.customizeMiniappEdit',
        isMenu: false
      }
    },
    {
      path: '/customize/website/websiteList',
      name: 'website_websiteList',
      component: () => import('@/views/customize/website/websiteList.vue'),
      meta: {
        title: 'menus.customizeWebsiteList',
        icon: 'el-icon-platform'
      }
    },
    {
      path: '/customize/website/websiteDetail',
      name: 'website_websiteDetail',
      component: () => import('@/views/customize/website/websiteDetail.vue'),
      meta: {
        title: 'menus.customizeWebsiteEdit',
        isMenu: false
      }
    },
    {
      path: '/customize/website/dataListPageDetail',
      name: 'customize_dataListPageDetail',
      component: () => import('@/views/customize/website/dataListPageDetail.vue'),
      meta: {
        title: 'customer.listpage',
        isMenu: false
      }
    },
    {
      path: '/customize/module/index',
      name: 'customize_module',
      component: () => import('@/views/customize/module/index.vue'),
      meta: {
        title: 'menus.customizeModule',
        icon: 'el-icon-Brush'
      }
    },
    {
      path: '/customize/nav/index',
      name: 'customize_nav',
      component: () => import('@/views/customize/nav/index.vue'),
      meta: {
        title: 'menus.customizeNav',
        icon: 'el-icon-Brush'
      }
    },
    {
      path: '/customize/theme/index',
      name: 'customize_theme',
      component: () => import('@/views/customize/theme/index.vue'),
      meta: {
        title: 'menus.customizeTheme',
        icon: 'el-icon-HelpFilled'
      }
    },
  ]
} as RouteRecordRaw;
